
import { Building, User, CheckCircle, XCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ClaimRequest, ClaimRequestActionProps } from './ClaimRequestInterface';

interface PendingClaimRequestCardProps extends ClaimRequestActionProps {
  request: ClaimRequest;
}

const PendingClaimRequestCard = ({ request, onApprove, onReject }: PendingClaimRequestCardProps) => {
  return (
    <Card key={request.id} className="overflow-hidden">
      <CardHeader className="bg-gray-50 pb-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <Building className="w-4 h-4 text-redflags-red" />
            <CardTitle className="text-lg">{request.company_name}</CardTitle>
          </div>
          <Badge className="bg-amber-500">Pending</Badge>
        </div>
        <CardDescription>
          Requested on {new Date(request.created_at).toLocaleDateString()}
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-4">
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <User className="w-4 h-4 text-gray-500" />
            <div className="text-sm">
              <p className="font-medium">{request.full_name}</p>
              <p className="text-redflags-gray">{request.job_title}</p>
            </div>
          </div>
          
          <div>
            <p className="text-sm text-redflags-gray mb-1">Email:</p>
            <p className="text-sm">{request.email}</p>
          </div>
          
          <div>
            <p className="text-sm text-redflags-gray mb-1">Message:</p>
            <p className="text-sm bg-gray-50 p-3 rounded">{request.message}</p>
          </div>
          
          <div className="flex justify-end space-x-3 pt-2">
            <Button 
              variant="outline"
              size="sm"
              className="border-red-300 text-red-700 hover:bg-red-50"
              onClick={() => onReject(request)}
            >
              <XCircle className="w-4 h-4 mr-1" />
              Reject
            </Button>
            <Button 
              size="sm"
              className="bg-green-600 hover:bg-green-700 text-white"
              onClick={() => onApprove(request)}
            >
              <CheckCircle className="w-4 h-4 mr-1" />
              Approve
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PendingClaimRequestCard;
